import { connect } from 'react-redux'

const activeYears = process.env.REACT_APP_ACTIVE_ELECTION_YEARS.split(',')

const mapStateToProps = ({ futureFormSubmitted, lead: { year } }) => ({
  futureFormSubmitted,
  isFutureYear: !(year && activeYears.find((activeYear) => activeYear === year)),
})

export default connect(mapStateToProps)


// WEBPACK FOOTER //
// ./src/components/FutureElectionScene/futureElectionSceneContainer.js